module.exports = __webpack_public_path__ + "img/close.b25372e5.svg";